import type { ICategory } from "app/common/services/categoryService.types";
import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

import {
    EDIT_INDUSTRY_ON_ARRIVAL_PARAM,
    INDUSTRY_OVERVIEW_STATE,
    INDUSTRY_LEADERS_STATE,
} from "../MarketBuilder.types";

type NavigateToMarketOptions = {
    /** Opens this industry's editor on arrival; only the Overview supports it. */
    editIndustryId?: string;
};

/** Navigates to `market`; resolves once the route has changed and rejects when it fails. */
export const navigateToCategory = (
    market: ICategory,
    country?: number,
    { editIndustryId }: NavigateToMarketOptions = {},
): Promise<unknown> => {
    const { returnToState } = proNavigator.getParams();
    const hasIndustryOverviewClaim = isAvailable(swSettings.components.WebMarketResearchOverviewHome);
    const defaultTargetState = hasIndustryOverviewClaim ? INDUSTRY_OVERVIEW_STATE : INDUSTRY_LEADERS_STATE;

    const resolvedState = returnToState || defaultTargetState;
    const opensEditor = !!editIndustryId && resolvedState === INDUSTRY_OVERVIEW_STATE;

    const stateConfig = proNavigator.getState(resolvedState);
    const configId = proNavigator.getConfigId(stateConfig);
    const defaultParams = swSettings.components[configId]?.defaultParams ?? {};

    return proNavigator.go(resolvedState, {
        ...defaultParams,
        webSource: "Total",
        category: market.forUrl,
        country: country ?? defaultParams.country,
        ignoreFilterConsistency: true,
        ...(opensEditor && { [EDIT_INDUSTRY_ON_ARRIVAL_PARAM]: editIndustryId }),
    });
};

export const navigateToMarket = (marketName: string, country?: number, options: NavigateToMarketOptions = {}) => {
    const market = UserCustomCategoryService.getCustomCategoryByName(marketName);
    if (!market) {
        return;
    }

    void navigateToCategory(market, country, options);
};
